import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import wallet from '../../../assets/icons/backOffice/Packages/wallet.svg';
import {
  copyLink,
  formatUSD,
  SendingTokenType,
  showNetworkType,
  showTokenType,
  USDT
} from '../../../helpers/helperFunctions';
import { MY_HUBS_ORDERS, ORDERS } from '../../../routes/routes';
import { CaptionText, H2, H3, P3 } from '../../../styles/FontStyles';
import { Button, Flexed } from '../../../styles/GlobalComponents';
import { color, colors } from '../../../styles/GlobalStyles';
import { Icon, IconCopy } from '../../../styles/Icons';
import { NetworkType } from '../../../types/types';
import { SelectedUSDT } from '../Marketplace.styled';
import { useAppSelector } from '../../../app/hooks';

interface SuccessProps {
  selectedPackage: any;
  selectedNetwork: any;
  selectedToken: any;
}

export const Success = ({
  selectedPackage,
  selectedNetwork,
  selectedToken
}: SuccessProps) => {
  const { t } = useTranslation('packages');
  const history = useHistory();

  const { userPackage } = useAppSelector((state) => state.marketplace);

  return (
    <>
      <div>
        <P3 bold mb='8' mt='20' color={colors.neutral900}>
          {t('waiting.you_selected')}
        </P3>

        <H3 mb='5' color={colors.secondary100}>
          {selectedPackage?.name}
        </H3>

        <P3 mb='8' mt='20' color={colors.neutral900}>
          {t('waiting.text1')}
        </P3>

        <P3 mb='8' mt='20' color={colors.neutral900}>
          {t('waiting.text2')}
        </P3>

        <P3 mb='8' mt='20' color={colors.neutral900}>
          {t('waiting.text3')}
        </P3>

        <P3 bold mb='8' mt='20' color={colors.neutral900}>
          {t('waiting.payment_amount')}
        </P3>

        <SelectedUSDT>{formatUSD(userPackage?.totalPrice)}</SelectedUSDT>

        <P3 bold mb='8' mt='20' color={colors.neutral900}>
          Selected {t('waiting.network')}
        </P3>

        <SelectedUSDT>{showNetworkType(selectedNetwork)} </SelectedUSDT>

        <P3 bold mb='8' mt='20' color={colors.neutral900}>
          Selected Token
        </P3>

        <SelectedUSDT>{selectedToken.token.toUpperCase()}</SelectedUSDT>

        <P3 bold mb='8' mt='20' color={colors.neutral900}>
          {t('waiting.wallet_address')}
        </P3>

        <SelectedUSDT
          onClick={() => {
            copyLink(userPackage?.paymentAddress, t('waiting.copied'));
          }}
          style={{ cursor: 'pointer' }}>
          <div className='truncated'>
            <div>{userPackage?.paymentAddress}</div>
          </div>

          <img
            src={wallet}
            alt='withdraw'
            style={{ width: 16, marginLeft: 10 }}
          />
        </SelectedUSDT>
      </div>

      <Flexed justifyCenter mt='40'>
        <Button
          onClick={() => {
            history.push(MY_HUBS_ORDERS);
          }}>
          Close
        </Button>
      </Flexed>
    </>
  );
};
